import { SplitButton } from 'primereact/splitbutton';
import React from 'react';

import { MenuVariantElementProps } from '../use-tool-bar';

export const historyMenuMedium =
  ({ hideLabel }: { hideLabel: boolean }) =>
  ({ hook }: MenuVariantElementProps) => {
    const values = hook();
    if (values?.type == 'node-history') {
      const {
        actions: { undo, redo, undoSelectable, redoSelectable },
        undoHistoryMenuModel,
        redoHistoryMenuModel,
        onOpenDropdown,
      } = values;

      return (
        <>
          <div style={{ gridColumn: '1 / 2', gridRow: '1 / 2' }}>
            <SplitButton
              onClick={() => undo()}
              label={hideLabel ? undefined : 'Undo'}
              model={undoHistoryMenuModel}
              className="p-button-text"
              disabled={!undoSelectable}
              icon="pi ri-arrow-go-back-line"
              dropdownIcon="pi pi-chevron-up"
              menuStyle={{ maxHeight: '50%', overflow: 'auto', width: 525 }}
              // @ts-ignore
              transitionOptions={{ onEnter: onOpenDropdown }}
            />
          </div>
          <div style={{ gridColumn: '1 / 2', gridRow: '2 / 3' }}>
            <SplitButton
              onClick={() => redo()}
              label={hideLabel ? undefined : 'Redo'}
              model={redoHistoryMenuModel}
              className="p-button-text"
              disabled={!redoSelectable}
              icon="pi ri-arrow-go-forward-line"
              dropdownIcon="pi pi-chevron-up"
              menuStyle={{ maxHeight: '50vh', overflow: 'auto', width: 525 }}
              // @ts-ignore
              transitionOptions={{ onEnter: onOpenDropdown }}
            />
          </div>
        </>
      );
    }
    throw new Error('Unknown or missing hook or hook type.');
  };
